import { Routes } from '@angular/router'
import { AuthGuard } from '@shared/guards/auth.guard'
import { DashboardGuard } from '@shared/guards/dashboard.guard'
import {
  NgxGfmoneyCreateMessageComponent,
  NgxGfmoneyMessageComponent,
  NgxGfmoneyMessagesComponent,
  NgxGfmoneyMessagesModule,
} from '@yuri.karkhachev/ngx-gfmoney-messages'

import { OldBoardGuard } from '@shared/guards/old-board.guard'
import { importProvidersFrom } from '@angular/core'
import { environment } from '@environments/environment'

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@src/app/flow/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      { path: '', redirectTo: '/loan-details', pathMatch: 'full' },
      { path: 'error', loadComponent: () => import('@src/app/flow/error/error.component').then(m => m.ErrorComponent) },
      {
        path: 'loan-details',
        loadComponent: () =>
          import('@src/app/flow/loan-details/loan-details.component').then(m => m.LoanDetailsComponent),
      },
      {
        path: 'home',
        loadComponent: () => import('@src/app/flow/index-page/index-page.component').then(m => m.IndexPageComponent),
      },
      /*{ path: 'loan-details', redirectTo: '/maintenance', pathMatch: 'full' },
      { path: 'home', redirectTo: '/maintenance', pathMatch: 'full' },*/
      {
        path: 'maintenance',
        loadComponent: () =>
          import('@src/app/flow/maintenance/maintenance.component').then(m => m.MaintenanceComponent),
      },
      {
        path: 'phone-verification',
        loadComponent: () =>
          import('@src/app/flow/phone-verification-page/phone-verification-page.component').then(
            m => m.PhoneVerificationPageComponent,
          ),
      },
      {
        path: 'customer-details',
        loadComponent: () =>
          import('@src/app/flow/customer-details/customer-details.component').then(m => m.CustomerDetailsComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'internal-checks',
        loadComponent: () =>
          import('@src/app/flow/internal-checks/internal-checks.component').then(m => m.InternalChecksComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'transactions-check',
        loadComponent: () =>
          import('@src/app/flow/transactions-check/transactions-check.component').then(
            m => m.TransactionsCheckComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'transactions-check-retry',
        loadComponent: () =>
          import('@src/app/flow/transactions-check-retry/transactions-check-retry.component').then(
            m => m.TransactionsCheckRetryComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'transactions-check-redirect',
        loadComponent: () =>
          import('@src/app/flow/transactions-check-redirect/transactions-check-redirect.component').then(
            m => m.TransactionsCheckRedirectComponent,
          ),
      },
      {
        path: 'earnings-proof',
        loadComponent: () =>
          import('@src/app/flow/earnings-proof/earnings-proof.component').then(m => m.EarningsProofComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'housing-cost-verification',
        loadComponent: () =>
          import('@src/app/flow/housing-cost-verification/housing-cost-verification.component').then(
            m => m.HousingCostVerificationComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'nemid-check',
        loadComponent: () => import('@src/app/flow/nemid-check/nemid-check.component').then(m => m.NemidCheckComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'nemid-check-response',
        loadComponent: () =>
          import('@src/app/flow/nemid-check-response/nemid-check-response.component').then(
            m => m.NemidCheckResponseComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'nemid-check-results',
        loadComponent: () =>
          import('@src/app/flow/nemid-check-results/nemid-check-results.component').then(
            m => m.NemidCheckResultsComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'identity-check-results',
        loadComponent: () =>
          import('@src/app/flow/identity-check-results/identity-check-results.component').then(
            m => m.IdentityCheckResultsComponent,
          ),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('@src/app/flow/summary-page/summary-page.component').then(m => m.SummaryPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'tax-information',
        loadComponent: () =>
          import('@src/app/flow/tax-information/tax-information.component').then(m => m.TaxInformationComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'decision-rejected',
        loadComponent: () =>
          import('@src/app/flow/decision-rejected-page/decision-rejected-page.component').then(
            m => m.DecisionRejectedPageComponent,
          ),
      },
      {
        path: 'decision-resume/:guid',
        loadComponent: () =>
          import('@src/app/flow/decision-resume/decision-resume.component').then(m => m.DecisionResumeComponent),
      },
      {
        path: 'decision-success',
        loadComponent: () =>
          import('@src/app/flow/decision-success-page/decision-success-page.component').then(
            m => m.DecisionSuccessPageComponent,
          ),
      },
      {
        path: 'decision-pending',
        loadComponent: () =>
          import('@src/app/flow/decision-pending-page/decision-pending-page.component').then(
            m => m.DecisionPendingPageComponent,
          ),
      },
      {
        path: 'resume/:guid',
        loadComponent: () =>
          import('@src/app/flow/resume-flow-page/resume-flow-page.component').then(m => m.ResumeFlowPageComponent),
      },
      {
        path: 'r/:guid',
        loadComponent: () =>
          import('@src/app/flow/resume-flow-page/resume-flow-page.component').then(m => m.ResumeFlowPageComponent),
      },
      {
        path: 'brokers/:guid',
        loadComponent: () =>
          import('@src/app/flow/brokers-page/brokers-page.component').then(m => m.BrokersPageComponent),
      },
      {
        path: 'unsub/:guid',
        loadComponent: () =>
          import('@src/app/flow/unsubscribe-customer/unsubscribe-customer.component').then(
            m => m.UnsubscribeCustomerComponent,
          ),
      },
      {
        path: 'auth-user/:linkId',
        loadComponent: () => import('@src/app/flow/auth-user/auth-user.component').then(m => m.AuthUserComponent),
      },
      {
        path: 'cancel-app/:guid',
        loadComponent: () => import('@src/app/flow/cancel-app/cancel-app.component').then(m => m.CancelAppComponent),
      },
      { path: 'pay', loadComponent: () => import('@src/app/flow/pay/pay.component').then(m => m.PayComponent) },
      { path: 'p', loadComponent: () => import('@src/app/flow/pay/pay.component').then(m => m.PayComponent) },
      {
        path: 'pay-redirect',
        loadComponent: () =>
          import('@src/app/flow/pay-redirect/pay-redirect.component').then(m => m.PayRedirectComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'bankid-auth',
        loadComponent: () => import('@src/app/flow/bankid-auth/bankid-auth.component').then(m => m.BankidAuthComponent),
      },
      {
        path: 'loan-to-card-success',
        loadComponent: () =>
          import('@src/app/flow/loan-to-card-success/loan-to-card-success.component').then(
            m => m.LoanToCardSuccessComponent,
          ),
      },
    ],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('@src/app/dashboard/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      { path: '', redirectTo: '/dashboard-visa/login', pathMatch: 'full' },
      { path: 'login', redirectTo: '/dashboard-visa/login' },
      {
        path: 'invoices',
        loadComponent: () =>
          import('@src/app/dashboard/invoices-page/invoices-page.component').then(m => m.InvoicesPageComponent),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'transactions',
        loadComponent: () =>
          import('@src/app/dashboard/transactions-page/transactions-page.component').then(
            m => m.TransactionsPageComponent,
          ),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'help',
        loadComponent: () => import('@src/app/dashboard/help-page/help-page.component').then(m => m.HelpPageComponent),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'home',
        loadComponent: () => import('@src/app/dashboard/home-page/home-page.component').then(m => m.HomePageComponent),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('@src/app/dashboard/profile-page/profile-page.component').then(m => m.ProfilePageComponent),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'decision-pending/:state',
        loadComponent: () =>
          import('@src/app/dashboard/decision-pending/decision-pending.component').then(
            m => m.DecisionPendingComponent,
          ),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'decision-declined',
        loadComponent: () =>
          import('@src/app/dashboard/decision-declined/decision-declined.component').then(
            m => m.DecisionDeclinedComponent,
          ),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'payment-free-month',
        loadComponent: () =>
          import('@src/app/dashboard/payment-free-month/payment-free-month.component').then(
            m => m.PaymentFreeMonthComponent,
          ),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'payment-plan-setup',
        loadComponent: () =>
          import('@src/app/dashboard/payment-plan-setup/payment-plan-setup.component').then(
            m => m.PaymentPlanSetupComponent,
          ),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'payment-type-selection',
        loadComponent: () =>
          import('@src/app/dashboard/payment-type-selection/payment-type-selection.component').then(
            m => m.PaymentTypeSelectionComponent,
          ),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'customer-details-renew',
        loadComponent: () =>
          import('@src/app/dashboard/customer-details/customer-details.component').then(
            m => m.CustomerDetailsComponent,
          ),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'transactions-check',
        loadComponent: () =>
          import('@src/app/dashboard/transactions-check/transactions-check.component').then(
            m => m.TransactionsCheckComponent,
          ),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'transactions-check-status',
        loadComponent: () =>
          import('@src/app/dashboard/transactions-check-status/transactions-check-status.component').then(
            m => m.TransactionsCheckStatusComponent,
          ),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'update-customer-details',
        loadComponent: () =>
          import('@src/app/dashboard/update-customer-details/update-customer-details.component').then(
            m => m.UpdateCustomerDetailsComponent,
          ),
        canActivate: [OldBoardGuard],
      },
      {
        path: 'kyc-pending',
        loadComponent: () =>
          import('@src/app/dashboard/kyc-pending/kyc-pending.component').then(m => m.KycPendingComponent),
        canActivate: [OldBoardGuard],
      },
      { path: 'messages/create', component: NgxGfmoneyCreateMessageComponent, canActivate: [OldBoardGuard] },
      { path: 'messages/view/:id', component: NgxGfmoneyMessageComponent, canActivate: [OldBoardGuard] },
      { path: 'messages/:type', component: NgxGfmoneyMessagesComponent, canActivate: [OldBoardGuard] },
    ],
    providers: [
      importProvidersFrom(
        NgxGfmoneyMessagesModule.forRoot({
          allowedFileTypes: 'image/jpeg,image/png,.pdf,.txt',
          apiUrl: `${environment.apiHost}`,
          brand: environment.companyName,
          dateFormat: 'yyyy-MM-dd HH:mm',
          homePagePath: '/dashboard',
        }),
      ),
    ],
  },
  {
    path: 'dashboard-visa',
    loadComponent: () => import('@visa/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      { path: '', redirectTo: '/dashboard-visa/login', pathMatch: 'full' },
      {
        path: 'login',
        loadComponent: () => import('@visa/login-page/login-page.component').then(m => m.LoginPageComponent),
      },
      {
        path: 'setup',
        loadComponent: () => import('@visa/setup/setup.component').then(m => m.SetupComponent),
      },
      {
        path: 'transactions',
        loadComponent: () => import('@visa/transactions/transactions.component').then(m => m.TransactionsComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'invoices',
        loadComponent: () => import('@visa/invoices-page/invoices-page.component').then(m => m.InvoicesPageComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'help',
        loadComponent: () => import('@visa/help-page/help-page.component').then(m => m.HelpPageComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'home',
        loadComponent: () => import('@visa/home-page/home-page.component').then(m => m.HomePageComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'profile',
        loadComponent: () => import('@visa/profile-page/profile-page.component').then(m => m.ProfilePageComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'card',
        loadComponent: () => import('@visa/credit-card/credit-card.component').then(m => m.CreditCardComponent),
        canActivate: [DashboardGuard],
      },
      { path: 'messages/create', component: NgxGfmoneyCreateMessageComponent, canActivate: [DashboardGuard] },
      { path: 'messages/view/:id', component: NgxGfmoneyMessageComponent, canActivate: [DashboardGuard] },
      { path: 'messages/:type', component: NgxGfmoneyMessagesComponent, canActivate: [DashboardGuard] },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('./flow/error/error.component').then(m => m.ErrorComponent),
  },
]
